import CityPageTemplate from "../city-template/CityPageTemplate";
import { frederickConfig } from "./data";

export default function FrederickPage() {
  return <CityPageTemplate config={frederickConfig} />;
}